import { stateKey } from '../../../../app/state-key.js';
import { buildController, } from '../../../controller/headless-controller.js';
/**
 * Creates a `Summary` sub-controller.
 *
 * @param engine - The headless commerce engine.
 * @param props - The configurable `Summary` properties.
 * @returns A `Summary` sub-controller.
 */
export const buildCoreSummary = (engine, props) => {
    const controller = buildController(engine);
    const { options: { numberOfProductsSelector, responseIdSelector, isLoadingSelector, errorSelector, pageSelector, perPageSelector, totalEntriesSelector, enrichSummary, }, } = props;
    const getState = () => engine[stateKey];
    const page = () => pageSelector(getState());
    const perPage = () => perPageSelector(getState());
    const totalNumberOfProducts = () => totalEntriesSelector(getState());
    const firstSearchExecuted = () => !!responseIdSelector(getState());
    const hasProducts = () => firstSearchExecuted() && totalNumberOfProducts() > 0;
    const firstProduct = () => (hasProducts() ? page() * perPage() + 1 : 0);
    const lastProduct = () => hasProducts()
        ? firstProduct() + (numberOfProductsSelector(getState()) - 1)
        : 0;
    return {
        ...controller,
        get state() {
            return {
                firstRequestExecuted: firstSearchExecuted(),
                firstProduct: firstProduct(),
                lastProduct: lastProduct(),
                totalNumberOfProducts: totalNumberOfProducts(),
                hasProducts: hasProducts(),
                isLoading: isLoadingSelector(getState()),
                hasError: errorSelector(getState()) !== null,
                ...(enrichSummary ? enrichSummary(getState()) : {}),
            };
        },
    };
};
